import { render, staticRenderFns } from "./ChipContainer.vue?vue&type=template&id=27725872&scoped=true"
import script from "./ChipContainer.vue?vue&type=script&lang=ts"
export * from "./ChipContainer.vue?vue&type=script&lang=ts"
import style0 from "./ChipContainer.vue?vue&type=style&index=0&id=27725872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27725872",
  null
  
)

export default component.exports